export default {
    USER_GROUP(state, items) {
        state.items = items
    }
}